module.exports = __webpack_public_path__ + "static/media/success-dark.5c12df8b.svg";